import {remCalc} from '_themeUtils'

const container = {
    Container: {
        baseStyle: {
            px: {base: 'spacing.4'},
            w: {base: '100%', xl: '92%'},
            maxW: remCalc(1950),
        },
        variants: {
            plpContainer: {
                w: {base: '100%', xl: '100%'},
                maxW: 'none',
            },
        },
    },
    sizes: {
        container: {
            base: remCalc(1950),
            sm: remCalc(1950),
            xs: remCalc(1950),
            md: remCalc(1950),
            xl: remCalc(1950),
            xxl: remCalc(1950),
            '2xl': remCalc(1950),
        },
    },
}

export default container
